module.exports = __webpack_public_path__ + "img/Rectangle 217.0b7dd4de.png";